import React, { ReactElement } from 'react';
import './Rating.scss';
import { Genre } from '../../../../Models/Series';
import { Readable } from '../../../../Models/Product/Readable';
import dayjs from 'dayjs';
import { removeFromArray } from '../../../../utils/utils';
import { TryParseTrimText } from '../../../../Devon/MathFractions';

const tableTitles = [
    'Rating',
    'Pages',
    'Print Release',
    'Print Format',
    'ISBN',
    'Dimensions',
    'E-Book Release',
    'EISBN',
];


interface TagsProps {
    readable: Readable;
    ageRating: string;
    trim?: string;
}

const Rating = ({ readable, ageRating, trim }: TagsProps): ReactElement => {
    const tableValues = [
        ageRating!!,
        readable?.pageCount,
        readable?.printReleaseDate?.format('MMM D, YYYY'),
        readable?.coverType,
        readable?.isbn,
        trim,
        readable?.digitalReleaseDate?.format('MMM D, YYYY'),
        readable?.eisbn,
    ];

    const isbnExists = tableValues[4];
    const dimensionsExists = tableValues[5];
    const eisbnExists = tableValues[7];

    let tempData = tableTitles.map((title, index) => {
        return { title: title, value: tableValues[index] };
    });

    if (readable && isbnExists === '') {
        tempData = tempData.filter(data => data.title !== 'ISBN' && data.title !== 'Print Release' && data.title !== 'Print Format' && data.title !== 'Dimensions');
    }

    if (readable && eisbnExists === '') {
        tempData = tempData.filter(data => data.title !== 'EISBN' && data.title !== 'E-Book Release');
    }


    return (
        <div className='product-rating-table-container'>
            <table className='product-rating-table'>

                <thead>
                <tr>
                    <th>
                        {tempData?.filter(data => !!data.value).map((data, index) => {
                            return <div key={index}>
                                <div key={index} className={'product-rating-table-title-value-wrapper'}>
                                    <div className={'product-rating-table-title-wrapper'}>
                                        <span className={'product-rating-table-title'}>{data.title}:</span>
                                    </div>

                                    {
                                        data.title===`Dimensions`?

                                            (<div className={'product-rating-table-value-wrapper'}>
                                                <span
                                                    className={'product-rating-table-title'}>{TryParseTrimText(data.value as string).result}</span>
                                            </div>)
                                            :
                                            (<div className={'product-rating-table-value-wrapper'}>
                                                <span className={'product-rating-table-title'}>{data.value}</span>
                                            </div>)
                                    }
                                </div>
                                {((dimensionsExists ? data.title === 'Dimensions' : data.title === 'ISBN') && eisbnExists !== '') || data.title === 'Rating' || data.title === 'Pages'
                                    ? <div className={`line-separator-product-rating ${data.title === 'Rating' || data.title === 'Pages' ? 'line-separator-product-rating-mt' : ''}`} />
                                    : null}
                            </div>;

                        })}

                    </th>
                </tr>
                </thead>

                <tbody>
                <tr>
                    <td colSpan={2}>
                        <div className='product-rating-table-tags-tags-container'>
                            <span className='product-rating-table-tags-tag-text'>Tags: </span>
                            <div className='product-rating-table-tags-tags-wrapper'>
                                {readable?.genres.map((tag) => {
                                    return <span key={tag.id}
                                                 className='product-rating-table-tags-tag'>{tag.name}</span>;
                                })}
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    );
};

export default Rating;
